import { deleteRequest } from '../..';

const deleteSpace = (LocationId: string) => deleteRequest('locations/space', { LocationId });

export default deleteSpace;
